"use strict";function locationChatMessage$(a){return ddSdk_1.ddSdk.invokeAPI(apiName,a)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.locationChatMessage$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.chat.locationChatMessage";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.7.6"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.7.6"},_a)),exports.locationChatMessage$=locationChatMessage$,exports.default=locationChatMessage$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/chat/locationChatMessage.js
// module id = 918
// module chunks = 106